import React from 'react';
import { Badge, Button } from "@shopify/polaris";
import { CampaignStatusEnum } from '../pages/CampaignsPage/components/CampaignStatusEnum';

export const getStatusBadge = (status, onOpenSubscriptionDialog, doneCount, selectionCount, endDate = null) => {
  const getProgressContent = (done, total) => {
    if (done > 0 && total) {
      return `${done}/${total}`;
    } else if (done > 0) {
      return `${done}`;
    }
    return "";
  };

  switch (status) {
    case CampaignStatusEnum.Scheduled:
      return <Badge tone="info">Scheduled</Badge>;
    case CampaignStatusEnum.Starting:
      return (
        <Badge tone="info" progress="partiallyComplete">
          Processing  {getProgressContent(doneCount, selectionCount)}
        </Badge>
      );
    case CampaignStatusEnum.Started:
      const now = new Date();
      const fourMinutesFromNow = new Date(now.getTime() + 4 * 60 * 1000);
      const twentyFourHoursAgo = new Date(now.getTime() - 24 * 60 * 60 * 1000);
      
      if (endDate && (
        (endDate <= fourMinutesFromNow && endDate > now) ||
        (endDate >= twentyFourHoursAgo && endDate <= now)
      )) {
        return <Badge tone="attention">Deactivate pending</Badge>;
      }
      return <Badge tone="success">Active</Badge>;
    case CampaignStatusEnum.Ending:
      return (
        <Badge tone="info" progress="partiallyComplete">
          Processing  {getProgressContent(doneCount, selectionCount)}
        </Badge>
      );
    case CampaignStatusEnum.Ended:
      return <Badge>Inactive</Badge>;
    case CampaignStatusEnum.FailedActivating:
      return <Badge tone="warning">Failed activating</Badge>;
    case CampaignStatusEnum.FailedDeactivating:
      return <Badge tone="warning">Failed deactivating</Badge>;
    case CampaignStatusEnum.FailedTooManyProducts:
      return <Badge tone="warning">Failed: Too many products</Badge>;
    case CampaignStatusEnum.SyncingProducts:
      return (
        <Badge tone="info" progress="partiallyComplete">
          Syncing {getProgressContent(doneCount)}
        </Badge>
      );
    case CampaignStatusEnum.PendingUpgrade:
      return (
        <Badge tone="warning-strong">
          <Button variant="monochromePlain" onClick={(e) => {
            e.stopPropagation();
            if (typeof onOpenSubscriptionDialog === 'function') {
              onOpenSubscriptionDialog();
            }
          }}>
            <u>Needs upgrade</u>
          </Button>
        </Badge>
      );
    default:
      return <Badge tone="info">Scheduled</Badge>;
  }
};

